"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RectangleTransformPointsMapping = void 0;
/**
 * Manages the mapping between the 8-point conceptual space and the
 * drawing-tools active point indices, based on which points are visible.
 *
 * Conceptual layout: [C0, M1, C2, M3, C4, M5, C6, M7]
 *   C0=BL (X-,Y-), C2=BR (X+,Y-), C4=TR (X+,Y+), C6=TL (X-,Y+)
 *   M1=bottom (Y-), M3=right (X+), M5=top (Y+), M7=left (X-)
 *
 * All four corners are always present in the single drawing-tools instance at
 * fixed DT indices: C0→0, C2→1, C4→2, C6→3.  Locked corners are listed in
 * `disabledDTIndices` so the DT renders them as non-interactive disabled
 * handles.
 */
class RectangleTransformPointsMapping {
    constructor(config = {}) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        // All four corners always occupy fixed DT slots: C0→0, C2→1, C4→2, C6→3.
        // EdgeControls (odd conceptual indices) remain -1 — they are EdgeControls.
        this.dtToConceptual = [0, 2, 4, 6];
        this.conceptualToDT = [0, -1, 1, -1, 2, -1, 3, -1];
        // Disabled corners are shown visually as locked (non-interactive) handles.
        this.lockedCornerConceptualIndices = [
            { ci: 0, show: (_b = (_a = config.corners) === null || _a === void 0 ? void 0 : _a.bottomLeft) !== null && _b !== void 0 ? _b : true },
            { ci: 2, show: (_d = (_c = config.corners) === null || _c === void 0 ? void 0 : _c.bottomRight) !== null && _d !== void 0 ? _d : true },
            { ci: 4, show: (_f = (_e = config.corners) === null || _e === void 0 ? void 0 : _e.topRight) !== null && _f !== void 0 ? _f : true },
            { ci: 6, show: (_h = (_g = config.corners) === null || _g === void 0 ? void 0 : _g.topLeft) !== null && _h !== void 0 ? _h : true },
        ]
            .filter(({ show }) => !show)
            .map(({ ci }) => ci);
        this.disabledDTIndices = this.lockedCornerConceptualIndices.map((ci) => this.conceptualToDT[ci]);
        // Build midpoint EdgeControls — one per enabled midpoint.
        this.edgeControls = [
            { mi: 1, c1: 0, c2: 2, show: (_k = (_j = config.edgeControls) === null || _j === void 0 ? void 0 : _j.bottom) !== null && _k !== void 0 ? _k : true },
            { mi: 3, c1: 2, c2: 4, show: (_m = (_l = config.edgeControls) === null || _l === void 0 ? void 0 : _l.right) !== null && _m !== void 0 ? _m : true },
            { mi: 5, c1: 4, c2: 6, show: (_p = (_o = config.edgeControls) === null || _o === void 0 ? void 0 : _o.top) !== null && _p !== void 0 ? _p : true },
            { mi: 7, c1: 6, c2: 0, show: (_r = (_q = config.edgeControls) === null || _q === void 0 ? void 0 : _q.left) !== null && _r !== void 0 ? _r : true },
        ]
            .filter(({ show }) => show)
            .map(({ mi, c1, c2 }) => ({
            conceptualEdgeControlIndex: mi,
            corner1CI: c1,
            corner2CI: c2,
        }));
    }
    // Push all four corner local-space points to the drawing tools.
    flushRectPoints(localPoints, drawingTools, temporary) {
        for (let di = 0; di < this.dtToConceptual.length; di++) {
            const ci = this.dtToConceptual[di];
            const p = localPoints[ci];
            drawingTools.movePoint(di, [p[0], p[1], p[2]], temporary, true);
        }
    }
}
exports.RectangleTransformPointsMapping = RectangleTransformPointsMapping;
//# sourceMappingURL=RectangleTransformPointsMapping.js.map